import {L} from "../lt-ng/landcare-toolkit";
import Item = L.tree.Item;
import {IRequestError} from "../lt-ng/portal-services";
import {FeatureAndUiState} from "./features-api/models";
import {Feature} from "ol";
import Point from "ol/geom/Point";
import {ILayerQueryLayer, ILayerQueryResult, IRequestAndCancel, ISMapQueryResult} from "./layer_query";
import {Geometry} from "ol/geom";
import SimpleGeometry from "ol/geom/SimpleGeometry";

export type AddFeatureMode = 'pin' | 'extent' | 'drawn' | 'predefined' | 'fromFile' | 'customLayer';

/**
 * Use enum member types to differentiate between reports - https://www.typescriptlang.org/docs/handbook/enums.html#union-enums-and-enum-member-types
 */
export enum ReportKind {
    pin = 'pin',
    area = 'area',
    multiplePin = 'multiplePin'
}

export enum AreaReportFeatureKind {
    extent = 'extent',
    drawn = 'drawn',
    predefined = 'predefined',
    customLayer = 'customLayer'
}

export interface RequestAndLayers<T> {
    request: IRequestAndCancel<T>;
    queriedLayers: Item[];
}

export interface IPointReport {
    response: {
        area: number;
        featureType: string;
        layers: ILayerQueryLayer[];
        poiType: string;
        pointHeight: number;
        region: string;
    }
}

export interface PointReportRequestAndLayers extends RequestAndLayers<IPointReport | IRequestError> {

}

export interface PinReport {
    userFeatures?: FeatureAndUiState;
    kind: ReportKind.pin;
    /*pinData: PinAndExtras;*/
    point: Feature<Point>;
    queryResults: {
        [layerIds: string]: PointReportRequestAndLayers;
    };
}

export interface MultiplePinReport {
    kind: ReportKind.multiplePin,
    reports: PinReport[];
}

export type AreaReportResult = ILayerQueryResult | ISMapQueryResult;

export interface AreaReportRequestAndLayers extends RequestAndLayers<AreaReportResult> {

}

export interface AreaQueryByLayerId {
    [layerIds: string]: AreaReportRequestAndLayers;
}

export interface IAreaReport {
    userFeatures?: FeatureAndUiState;
    kind: ReportKind.area;
    features: Feature<Geometry>[];
    geometry: SimpleGeometry;
    queryResults: AreaQueryByLayerId;
    revision?: number;
}

export interface ExtentAreaReport extends IAreaReport {
    featureKind: AreaReportFeatureKind.extent;
}

export interface DrawnAreaReport extends IAreaReport {
    featureKind: AreaReportFeatureKind.drawn;
}

export interface PredefinedAreaReport extends IAreaReport {
    featureKind: AreaReportFeatureKind.predefined;
    sourceLayer: Item;
}

export interface CustomLayerAreaReport extends IAreaReport {
    featureKind: AreaReportFeatureKind.customLayer;
    sourceLayer: Item;
}

export type AreaReport = ExtentAreaReport | DrawnAreaReport | PredefinedAreaReport | CustomLayerAreaReport;
export type FeatureReport =
    PinReport
    | ExtentAreaReport
    | DrawnAreaReport
    | PredefinedAreaReport
    | MultiplePinReport
    | CustomLayerAreaReport;

export interface ISharedFeatureControlState {
    paneTitle: string;
    featureMode: AddFeatureMode;
    activeQueryLayer: Item;
    activeReport: FeatureReport;
    featureLoading: boolean;
    fabMenuOpen?: boolean;
}
